import React, { useState, useEffect, useRef, useContext } from "react";
import SelectArrow from "../../../assets/images/select-arrow.svg";
import ClearSearch from "../../../assets/images/clear-search.svg";
import SelectedTick from "../../../assets/images/selected-tick.svg";
import styled from "styled-components";
import LayoutContext from "../../../contexts/LayoutContext";
const StyledPage = styled.div`
    &.frame-295922566,
    &.frame-295922566 * {
        box-sizing: border-box;
    }
    &.frame-295922566 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        margin-bottom: 30px;
    }
    .tab-large {
        border-radius: 10px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        height: 48px;

        border-right: 0px;
    }
    .frame-29503 {
        width: 87px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: no-drop;
    }
    .frame-29786 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .for-you {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-weight: 100;
        font-size: 16px;
        font-family: "ITC Avant Garde Gothic";
        line-height: 16.68px;
        opacity: 0.4;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .glow-on-hover.active {
        border: 1px solid #f7665f;
        background-color: #f7665f1a;
    }
    .glow-on-hover {
        width: 89px;
        height: 48px;
        border-radius: 10px;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        font-size: 16px;
        font-weight: 100;
        font-family: "ITC Avant Garde Gothic";
        cursor: pointer;
    }
    .frame-295922503 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 87px;
        height: 24px;
        position: relative;
    }

    @media (max-width: 992px) {
        &.frame-295922566 {
            height: 40px;
        }
        .frame-29503 {
            width: 80px;
        }
        .for-you,
        .global {
            font-size: 13.12px;
            line-height: 19.38px;
        }
        .frame-295922534 {
            width: 140px;
            height: 40px;
            padding: 0px 15px;
        }
        .recently-viewed {
            font-size: 13.81px;
            line-height: 19.38px;
        }
    }
`;

export default function BrandFilter({ setSkeletonLoding, setIsRecentBtnClicked, setSelectedBrandID, setActiveTab, activeTab }) {
    return (
        <>
            <StyledPage className="frame-295922566">
                <div className="tab-large">
                    <div className="frame-29503">
                        <div className="frame-29786">
                            <div className="for-you">For you</div>
                        </div>
                    </div>
                    <div className={`glow-on-hover ${activeTab === "Global" ? "active" : ""}`} onClick={() => setActiveTab("Global")}>
                        Global
                    </div>
                    <div
                        className={`glow-on-hover ${activeTab === "History" ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab("History");
                            setSkeletonLoding(true);
                            setSelectedBrandID("-");
                            setIsRecentBtnClicked(true);
                        }}>
                        History
                    </div>
                </div>
            </StyledPage>
        </>
    );
}
